import isApp from "@/utils/isApp";

const isMobile = window.innerWidth < 768 || isApp;

export default isMobile;
